"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectDepartmentApi = void 0;
exports.createProjectDepartmentApi = (axios) => ({
    listProjectDepartments(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/project/${props.projectId}/departments`)).data;
        });
    },
    createProjectDepartment({ projectId, departmentId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/project/${projectId}/department/${departmentId}`)).data;
        });
    },
    deleteProjectDepartment({ projectId, departmentId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/project/${projectId}/department/${departmentId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdERlcGFydG1lbnRBcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpL3Byb2plY3REZXBhcnRtZW50QXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsMEJBQTBCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzdELHNCQUFzQixDQUFDLEtBRTVCOztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxLQUFLLENBQUMsU0FBUyxjQUFjLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUMzRSxDQUFDO0tBQUE7SUFFSyx1QkFBdUIsQ0FBQyxFQUM1QixTQUFTLEVBQ1QsWUFBWSxHQUliOztZQUNDLE9BQU8sQ0FDTCxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsWUFBWSxTQUFTLGVBQWUsWUFBWSxFQUFFLENBQUMsQ0FDckUsQ0FBQyxJQUFJLENBQUM7UUFDVCxDQUFDO0tBQUE7SUFFSyx1QkFBdUIsQ0FBQyxFQUM1QixTQUFTLEVBQ1QsWUFBWSxHQUliOztZQUNDLE1BQU0sS0FBSyxDQUFDLE1BQU0sQ0FBQyxZQUFZLFNBQVMsZUFBZSxZQUFZLEVBQUUsQ0FBQyxDQUFDO1FBQ3pFLENBQUM7S0FBQTtDQUNGLENBQUMsQ0FBQyJ9